module.exports = __webpack_public_path__ + "img/error_room_new.317b96ca.png";